import { passengerTypeAction } from "../../../Actions/Index";
import { getMultiBookingTripOfferAction, IGetMultiBookingTripOfferActionParams } from "../../../Actions/LogicActions/MultiBooking/GetMultiBookingTripOfferAction";
import { saveMultiBookingPreferencesAction } from "../../../Actions/LogicActions/MultiBooking/SaveMultiBookingPreferencesAction";
import { getSeatingPreferencesAction } from "../../../Actions/LogicActions/Search/getSeatingPreferencesAction";
import { getTicketOptionsAction } from "../../../Actions/LogicActions/Search/GetTicketOptionsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { multiBookTree } from "../../../Orchestrator/ConstantTree";
import { getRecoilStateValue, removeFromStorage, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IPassenger, IUserResponse } from "../../../Orchestrator/Types/Index";
import { showNotification } from "../../../Services/notificationService";

class PlanMultiBookInitStep extends StepFlow {
    get stepName() { return "PlanMultiBookInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: multiBookTree.PlanMultiBook.Back.Click,
                handler: async (payload) => {
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "PlanMultiBookFlow",
                    });
                    const isAuthenticated = getRecoilStateValue("isAuthenticatedStateAtom")
                    if (isAuthenticated) {
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/search",
                        });
                    } else {
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/",
                        });
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: multiBookTree.ticketOptions.get,
                handler: async () => {
                    await getTicketOptionsAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: multiBookTree.seatingPreferences.get,
                handler: async () => {
                    await getSeatingPreferencesAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IGetMultiBookingTripOfferActionParams, void>({
                eventName: multiBookTree.PlanMultiBook.Continue.Click,
                handler: async ({ data }) => {
                    // only save if values have changed
                    const userData = getRecoilStateValue("userDataAtom") as IUserResponse;
                    if (userData && data?.formValues && data?.hasFormChanged) {
                        saveMultiBookingPreferencesAction.setParams({
                            userData: userData,
                            multiBookingPreferences: data.formValues
                        });
                        await saveMultiBookingPreferencesAction.execute();
                    }

                    getMultiBookingTripOfferAction.setParams(data!);
                    await getMultiBookingTripOfferAction.execute();
                    if (isActionRunSuccessfully(getMultiBookingTripOfferAction)) {
                        updateRecoilState("isMultiBookingStateAtom", true)
                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "PlanMultiBookFlow",
                        });
                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: "/multi-booking",
                        });
                    } else {
                        showNotification(
                            "error",
                            "Error",
                            getTranslatedMessage('multiBooking.failToRetrieveBookingOffer', "")
                        )
                    }
                }
            })
        )

    }

    async onExecute(): Promise<void> {
        console.log("Plan Multi Book Init Step Execute...........")

        const passengerRelatedAtoms = [
            "passengerStateAtom",
            "passengerTypesStateAtom",
            "selectedPassengersPerTypeStateAtom",
            "savedPassengerDetailAtom",
            "passengerMappingAtom",
            "areAllPassengerDetailsCompleteAtom",
            "selectedPassengerForCancelAtom",
            "selectedPassengerForCancelInBoundAtom",
            "selectedPassengersAtom",
            "allPassengerPriceAndAgeGroupAtom",
            "allPassengerPriceAndAgeGroupInBoundAtom",
            "selectedPassengersOutBoundAtom",
            "selectedPassengersInBoundAtom",
            "selectedPassengerForDateChangeAtom",
            "selectedPassengerForDateChangeInBoundAtom",
            "displayPassengerDataAtom",
            "passengerSeatCursorAtom",
            "selectedSeatsAtom"
        ];

        // Through removeFromStorage, NOT a hand-rolled localStorage key: atom
        // state lives in sessionStorage, so this loop was deleting keys that no
        // longer exist while the real entries survived to be restored by the
        // next hydratePersistedAtoms. Same mismatch clearBookingFlowAtoms had.
        passengerRelatedAtoms.forEach(atomKey => removeFromStorage(atomKey));

        updateRecoilState("passengerStateAtom", []);
        updateRecoilState("selectedPassengersPerTypeStateAtom", {});
        updateRecoilState("savedPassengerDetailAtom", []);
        updateRecoilState("passengerMappingAtom", []);
        updateRecoilState("areAllPassengerDetailsCompleteAtom", false);
        
        await passengerTypeAction.execute();
        updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
        updateRecoilState<IPassenger[]>("passengerStateAtom", []);
    }
}

export const PlanMultiBookInitStepDeclaration = new StepDefinition({
    stepName: "PlanMultiBookInit_Step",
    stepClass: PlanMultiBookInitStep
});